import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Project from "../Home/Project/Project";
import Header from "../Shared/Header/Header";

const AllProjects = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("projectsData.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <div>
      <Header></Header>
      <Container fluid="md" id="myAllPro">
        <Row className="justify-content-md-center">
          <Col lg="8">
            <h1 className="text-center my-5">Explore my all projects 👇</h1>
          </Col>
        </Row>
        <Row className="justify-content-sm-center">
          {projects.map((myProject) => (
            <Project key={myProject.id} myProject={myProject}></Project>
          ))}
        </Row>
        <div className="mb-5">
          <button type="button" class="btn-All">
            <a
              className="all-project text-decoration-none btn-All-link"
              href="https://github.com/mosheurpau"
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to github{"  "}
              <FontAwesomeIcon className="delete-icon" icon={faArrowRight} />
            </a>
          </button>
        </div>
      </Container>
    </div>
  );
};

export default AllProjects;
